<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <app-sidebar-menu></app-sidebar-menu>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>

    </div>
    <div class="layout-mask animate-fadein"></div>
    <app-footer></app-footer>
</div>
